<template>
    <div class="cardUploadStatus">
        <div class="cardUploadStatus__titleCard" v-if="isVisibleTitleCard">
            <h2>{{ titleCard }}</h2>
        </div>
       <div class="cardUploadStatus__statusBar" v-if="isVisibleStatus">
            <div class="statusBar__bar"  v-bind:class="{ 'barError': isError }">
                <div class="statusBar__bar2"  v-bind:class="{ 'barError': isError }"></div>
            </div>
            <div class="statusBar__statusDescription">
                <span>Status atual</span>
                <span>{{ status }} de 1</span>
            </div>
       </div>
       <div class="cardUploadStatus__fileDescription">
            <div class="fileDescription__icontitle">
                <img src="../../../public/images/FileText.svg" alt="" v-if="isVisibleIconFile">
                <img src="../../../public/images/status-check-icon.svg" v-if="isVisibleIconCheck">
                <div class="iconTitle__titles">
                    <h2 v-if="isVisibleTitle">{{ titleFile }}</h2>
                    <span @click="showImage" class="clickable">{{ subtitleFile }}</span>
                </div>
            </div>
            <img src="../../../public/images/ArrowClockwise.svg" @click="handleTryAgainClick" id="arrow" v-if="isVisibleIconArrow">
            <img src="../../../public/images/Trash.svg" @click="handleTryAgainClick" v-if="isVisibleIconTrash">
       </div>
    </div>
</template>
<script>

export default {
    props: {
        isVisibleTitleCard: {
            type: Boolean,
            default: true
        },
        titleCard: {
            type: String,
            required: true
        },
        isVisibleStatus: {
            type: Boolean,
            required: false,
            default: true
        },
        isVisibleTitle: {
            type: Boolean,
            required: false,
            default: false
        },
        isVisibleIconArrow: {
            type: Boolean,
            required: false,
            default: false
        },
        isVisibleIconTrash: {
            type: Boolean,
            default: true
        },
        isVisibleIconFile: {
            type: Boolean,
            default: true
        },
        isVisibleIconCheck: {
            type: Boolean,
            require: false,
            default: false
        },
        status: {
            type: String,
            required: true,
            default: '0'
        },
        titleFile: {
            type: String,
            required: true,
        },
        subtitleFile: {
            type: String,
            required: true,
        },
        isError: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        handleTryAgainClick() {
                this.$emit('try-again-click', this.titleCard);
        }
    }
}
</script>
<style lang="scss">
    @import "@vuxx/hounds/scss/abstracts/mixins";
    @import "@vuxx/hounds/scss/abstracts/variables";

    .cardUploadStatus {
        display: flex;
        flex-direction: column;
        gap: 18px;
        justify-content: center;
        align-self: center;
        padding: 16px;
        border-radius: 8px;
        box-shadow: 0px 4px 15px 0px #0000001A;
        background-color: #FFF;
        height: fit-content;
        width: 90%;

        @include breakpoint('medium') {
            width: 90%;
        }
        @include breakpoint('large') {
            width: 80%;
        }
    }
    .cardUploadStatus__titleCard h2 {
        font-size: 14px;
        font-weight: 500;
        color: #22232C;
    }
    .cardUploadStatus__statusBar {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
        height: auto;
    }
    .statusBar__bar {
        background-color: #F6F6F6;
        width: 100%;
        height: 8px;
        border-radius: 100px;
    }
    .statusBar__bar2 {
        background-color: #F6BE01;
        width: 50%;
        height: 8px;
        border-radius: 100px;
    }
    .barError {
        background-color: #D81F47 !important;
    }
    .statusBar__statusDescription {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .statusBar__statusDescription span {
        font-size: 10px;
        color: #595959;
        font-weight: 500;
    }
    .cardUploadStatus__fileDescription{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .cardUploadStatus__fileDescription img {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .fileDescription__icontitle{
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 16px;
    }
    .iconTitle__titles h2 {
        font-size: 14px;
        font-weight: 500;
        color: #22232C;
    }
    .iconTitle__titles span {
        font-size: 12px;
        font-weight: 400;
        color: #22232C;
    }
</style>
